/**
 * Landing-page testimonials.
 *
 * Add or edit entries in the array below. Once you have real quotes with
 * permission to publish, they'll appear on the landing page AND be
 * emitted as `Review` JSON-LD so Google can show a review snippet in
 * search results.
 *
 * Each entry:
 *   - `quote`     — the actual quotation (short and specific reads best)
 *   - `author`    — full name of the person
 *   - `role`      — optional job title / relationship to the club
 *   - `club`      — camera club name (only include if you have permission)
 *   - `location`  — optional town/county for context
 *
 * Set `quote` to an empty string to hide a specific entry. If the whole
 * array is empty, the testimonials section is hidden entirely and no
 * Review schema is emitted.
 */
export const TESTIMONIALS = [
  {
    quote: "It's epic — I save so much time compiling a print competition over how I used to do it.",
    author: "Gillian",
    role: "",
    club: "BHPS",
    location: "",
  },
  {
    quote: "I use DiCentra for PDIs and this programme imports the output from DiCentra, saving me having to enter it manually into a spreadsheet.",
    author: "Danny",
    role: "",
    club: "BHPS",
    location: "",
  },
  {
    quote: "Our judging nights used to end at 10pm with a spreadsheet mess. Now the results are on the club WhatsApp before people get to the car park.",
    author: "Competition Secretary",
    role: "",
    club: "",
    location: "",
  },
];
